const c = {
  name: "SchemeProducts",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,14,20,14z M16,20c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4
			c0,2.2-1.8,4-4,4C17.8,24,16,22.2,16,20z"/>
		<path class="st0" d="M11.5,31.5c0.6,0,1.1-0.2,1.6-0.5c5,3.1,11.7,2.5,16.1-1.8l0,0c4.4-4.4,5-11.1,1.8-16.1
			c0.3-0.5,0.5-1,0.5-1.6c0-1.7-1.3-3-3-3c-0.6,0-1.1,0.2-1.6,0.5c-5-3.1-11.7-2.5-16.1,1.8l0,0c-4.4,4.4-5,11.1-1.8,16.1
			c-0.3,0.5-0.5,1-0.5,1.6C8.5,30.1,9.9,31.5,11.5,31.5z M25.6,10.6c-0.1,0.3-0.2,0.6-0.2,1c0,1.7,1.3,3,3,3c0.3,0,0.7-0.1,1-0.2
			c2.5,4.2,2,9.8-1.7,13.4c-3.6,3.6-9.2,4.2-13.4,1.7c0.1-0.3,0.2-0.6,0.2-1c0-1.7-1.3-3-3-3c-0.3,0-0.7,0.1-1,0.2
			c-2.5-4.2-2-9.8,1.7-13.4C15.9,8.6,21.4,8,25.6,10.6z M27.5,11.5c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S27.5,12.1,27.5,11.5z
			 M11.5,27.5c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1C10.5,27.9,11,27.5,11.5,27.5z"/>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v30c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h30
			c1.7,0,3,1.3,3,3v30c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as SchemeProducts
};
